import { render } from "./App.vue?vue&type=template&id=38a3861a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=38a3861a&lang=scss"

import exportComponent from "/Volumes/MACOS-START/Projet-RegionPoleEmploi/Appli TESTEURS/TESTEURS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__